import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { Reveal } from "./Reveal";
import { MANIFESTO, IMAGES } from "@/data/site";

export default function Quality() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], [-60, 60]);

  return (
    <section id="quality" data-testid="quality-section" className="relative py-28 lg:py-40 border-t border-border overflow-hidden">
      <div className="max-w-[1600px] mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-20">
          {/* Sticky heading + image */}
          <div className="lg:col-span-5">
            <div className="lg:sticky lg:top-28">
              <Reveal>
                <span className="font-mono text-xs tracking-[0.35em] text-primary uppercase">05 — The Standard</span>
              </Reveal>
              <Reveal delay={0.1}>
                <h2 className="mt-5 font-display font-medium text-4xl lg:text-6xl tracking-tight leading-[1.02]">
                  Quality &amp; <span className="text-primary">R&amp;D</span>
                </h2>
              </Reveal>
              <Reveal delay={0.2}>
                <div ref={ref} className="mt-10 aspect-[3/4] overflow-hidden border border-border">
                  <motion.img
                    style={{ y }}
                    src={IMAGES.qualityRd}
                    alt="Precision tooling and R&D"
                    className="w-full h-[120%] object-cover"
                  />
                </div>
              </Reveal>
            </div>
          </div>

          {/* Numbered manifesto */}
          <div className="lg:col-span-7 lg:pt-16">
            {MANIFESTO.map((m, i) => (
              <Reveal key={m.id} delay={i * 0.05}>
                <div
                  data-testid={`manifesto-${m.id}`}
                  className="group py-10 border-t border-border flex gap-6 lg:gap-10"
                >
                  <span className="font-mono text-2xl lg:text-3xl text-primary shrink-0">{m.id}</span>
                  <div>
                    <h3 className="font-display text-2xl lg:text-4xl font-medium tracking-tight">{m.title}</h3>
                    <p className="mt-4 text-base text-muted-foreground leading-relaxed max-w-xl">{m.desc}</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
